/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AnalyticsRequest } from '../../models/analytics-request';
import { ApiResponseAnalytics } from '../../models/api-response-analytics';

export interface SearchAnalytics$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: AnalyticsRequest
}

export function searchAnalytics(http: HttpClient, rootUrl: string, params: SearchAnalytics$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAnalytics>> {
  const rb = new RequestBuilder(rootUrl, searchAnalytics.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseAnalytics>;
    })
  );
}

searchAnalytics.PATH = '/v1/api/ui/reporting/analytics-chat';
